var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-summary',{attrs:{"products":_vm.products,"selected-product":_vm.selectedProduct,"sectionTitle":"other-services","show-section-links":true}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }